import { Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { select, Store } from '@ngrx/store';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { MobileMenuActions } from './store/actions';
import { MOBILE_MENU_FEATURE, MobileMenuState, StateWithMobileMenu } from './store/mobile-menu-state';
import { MainSelectors } from './store/selectors';

@Injectable({
  providedIn: 'root',
})
export class MobileMenuStatePersistenceService {
  constructor(
    protected statePersistenceService: StatePersistenceService,
    protected store: Store<StateWithMobileMenu>,
    private baseStores: BaseStoreFacade,
  ) {}

  public sync(): void {
    this.statePersistenceService.syncWithStorage({
      key: MOBILE_MENU_FEATURE,
      state$: this.getState(),
      context$: this.baseStores.getActiveCode(),
      storageType: StorageSyncType.SESSION_STORAGE,
      onRead: (state: MobileMenuState) => this.onRead(state),
    });
  }

  protected getState(): Observable<MobileMenuState> {
    return this.store.pipe(select(MainSelectors.getMainFeatureState));
  }

  protected onRead(state: MobileMenuState): void {
    if (state) {
      this.store.dispatch(new MobileMenuActions.MobileMenuSetState(state.mobileMenu));
    }
  }
}
